import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import DowngradeAccountAlert from '@components/myScores/MessagesView/DowngradeAccountAlert'
import ExpiringCreditAccountAlert from '@components/myScores/MessagesView/ExpiringCreditAccountAlert'
import FirstPaymentFailureAccountAlert from '@components/myScores/MessagesView/FirstPaymentFailureAccountAlert'
import PaymentProblemAccountAlert from '@components/myScores/MessagesView/PaymentProblemAccountAlert'
import RefundConfirmationAccountAlert from '@components/myScores/MessagesView/RefundConfirmationAccountAlert'
import RefundFailureAccountAlert from '@components/myScores/MessagesView/RefundFailureAccountAlert'
import RemovePlanAccountAlert from '@components/myScores/MessagesView/RemovePlanAccountAlert'
import RenewalPaymentFailureAccountAlert from '@components/myScores/MessagesView/RenewalPaymentFailureAccountAlert'
import RenewalReminderAccountAlert from '@components/myScores/MessagesView/RenewalReminderAccountAlert'
import UpgradeAccountAlert from '@components/myScores/MessagesView/UpgradeAccountAlert'
import NonIdealState from '@components/shared/NonIdealState'
import AccountAlert from '@models/AccountAlert'
import { MessagesResponse } from '@pages/home/loaders/messages.loader'

interface Props {
  initialData: MessagesResponse
}

const MessagesView: React.FC<Props> = ({ initialData }) => {
  const { t } = useTranslation()
  const [messagesData, setMessagesData] = useState(initialData)

  // Reset the data when we get something new loaded
  useEffect(() => {
    setMessagesData(initialData)
  }, [initialData])

  const { alerts } = messagesData

  if (alerts.length === 0) {
    return <NonIdealState title={t('content.empty.messages.title')} icon="feedback" />
  }
  return (
    <>
      <div className="h-4 md:h-16" />
      {alerts.map(renderAlert)}
    </>
  )
}

export default MessagesView

function renderAlert(alert: AccountAlert): React.ReactNode {
  if (alert.type === 'DowngradeAccountAlert') return <DowngradeAccountAlert alert={alert} />
  if (alert.type === 'UpgradeAccountAlert' || alert.type === 'AddPlanAccountAlert')
    return <UpgradeAccountAlert alert={alert} />
  if (alert.type === 'RemovePlanAccountAlert') return <RemovePlanAccountAlert alert={alert} />
  if (alert.type === 'RefundConfirmationAccountAlert')
    return <RefundConfirmationAccountAlert alert={alert} />
  if (alert.type === 'FirstPaymentFailureAccountAlert')
    return <FirstPaymentFailureAccountAlert alert={alert} />
  if (alert.type === 'PaymentProblemAccountAlert')
    return <PaymentProblemAccountAlert alert={alert} />
  if (alert.type === 'RefundFailureAccountAlert') return <RefundFailureAccountAlert alert={alert} />
  if (
    alert.type === 'ExpiringPaidCreditAccountAlert' ||
    alert.type === 'ExpiringComplimentaryCreditAccountAlert'
  ) {
    return <ExpiringCreditAccountAlert alert={alert} />
  }
  if (alert.type === 'RenewalReminderAccountAlert')
    return <RenewalReminderAccountAlert alert={alert} />
  if (alert.type === 'RenewalPaymentFailureAccountAlert')
    return <RenewalPaymentFailureAccountAlert alert={alert} />
  return null
}
